/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { inject, Injectable } from "@angular/core";
import { catchError } from "rxjs/operators";
import { Observable, throwError } from "rxjs";
import { HttpErrorResponse, HttpHandler, HttpHeaderResponse, HttpInterceptor, HttpProgressEvent, HttpRequest, HttpResponse, HttpSentEvent, HttpUserEvent } from "@angular/common/http";
import {EnvironmentService} from "@irian-ro/util-environment";
import { ServiceWorkerVersionControlService } from "./service-worker-version-control.service";

@Injectable()
export class ServiceWorkerVersionInterceptor implements HttpInterceptor {

  private isServiceWorkerActive = inject(EnvironmentService).getEnvironmentProperty('serviceWorker');

  constructor( private serviceWorkerVersionControlService : ServiceWorkerVersionControlService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
    if(this.isServiceWorkerActive) {
      return next.handle(req)
        .pipe(
          catchError((err: HttpErrorResponse) => {
            this.serviceWorkerVersionControlService.checkForUpdates()
            return throwError(() => err)
          })
        );
    }
    else {
      return next.handle(req);
    }

  }
}
